var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("app-collapse", { attrs: { title: "Denominação do imóvel" } }, [
        _c(
          "div",
          { staticClass: "breakText" },
          [
            _c(
              "el-row",
              { attrs: { id: "denominacao-imovel" } },
              [
                _c("app-display", {
                  class:
                    _vm.compararImovelCancelamento &&
                    _vm.compararImovelCancelamento.mudouDenominacao
                      ? "text"
                      : "",
                  attrs: {
                    label: "Denominação:",
                    content: _vm.imovel.denominacao
                  }
                }),
                _c("app-display", {
                  class:
                    _vm.compararImovelCancelamento &&
                    _vm.compararImovelCancelamento.mudouMunicipio
                      ? "text"
                      : "",
                  attrs: {
                    label: "Município:",
                    content: _vm.imovel.municipio
                      ? _vm.imovel.municipio.nome
                      : ""
                  }
                }),
                _c("app-display", {
                  class:
                    _vm.compararImovelCancelamento &&
                    _vm.compararImovelCancelamento.mudouArea
                      ? "text"
                      : "",
                  attrs: {
                    label: "Área:",
                    content:
                      _vm.imovel.formattedValueArea !== "0,0000 hectare(s)"
                        ? _vm.getArea()
                        : ""
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "app-collapse",
        { attrs: { title: "Dados do título/Matrícula" } },
        [
          _c("el-row"),
          _c(
            "div",
            { staticClass: "breakText" },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    class:
                      _vm.compararImovelCancelamento &&
                      _vm.compararImovelCancelamento.mudouCNSMatricula
                        ? "text"
                        : "",
                    attrs: {
                      label: "CNS:",
                      content: _vm.getValue(_vm.imovel.cnsMatricula)
                    }
                  }),
                  _c("app-display", {
                    class:
                      _vm.compararImovelCancelamento &&
                      _vm.compararImovelCancelamento.mudouNumeroMatricula
                        ? "text"
                        : "",
                    attrs: {
                      label: "Número:",
                      content: _vm.getValue(_vm.imovel.numeroMatricula)
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    class:
                      _vm.compararImovelCancelamento &&
                      _vm.compararImovelCancelamento.mudouLivroMatricula
                        ? "text"
                        : "",
                    attrs: {
                      label: "Livro:",
                      content: _vm.getValue(_vm.imovel.livroMatricula)
                    }
                  }),
                  _c("app-display", {
                    class:
                      _vm.compararImovelCancelamento &&
                      _vm.compararImovelCancelamento.mudouNumeroFolhaMatricula
                        ? "text"
                        : "",
                    attrs: {
                      label: "N° da folha:",
                      content: _vm.getValue(_vm.imovel.numeroFolhaMatricula)
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Data do registro:",
                      content: _vm.formatDate(_vm.imovel.dataRegistro)
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Nome do cartório:",
                      content: _vm.getValue(_vm.imovel.nomeCartorio)
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Município do cartório:",
                      content: _vm.imovel.municipioCartorio.nome
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    class:
                      _vm.compararImovelCancelamento &&
                      _vm.compararImovelCancelamento.mudouNomeBeneficiarioTitulo
                        ? "text"
                        : "",
                    attrs: {
                      label: "Nome do beneficiário:",
                      content: _vm.getValue(_vm.imovel.nomeBeneficiarioTitulo)
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "N° do processo físico:",
                      content: _vm.getValue(
                        _vm.dadosProcessoFisico.numeroProcesso
                      )
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "N° do título:",
                      content: _vm.getValue(
                        _vm.dadosProcessoFisico.numeroTituloDominial
                      )
                    }
                  })
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c("app-display", {
                    attrs: {
                      label: "Data emissão do título:",
                      content: _vm.formatDate(
                        _vm.dadosProcessoFisico.dataEmissaoTituloDominial
                      )
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-175bfd1a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-175bfd1a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/cadastrosOnline/cancelamentoClausula/InformacoesImovelCancelamento.vue
// module id = null
// module chunks = 